import * as React from 'react';
import { Input as AntdInput, InputProps } from 'antd';
import styles from './styles.module.scss';

const Input = ({ ...props }: InputProps): React.ReactElement => (
  <AntdInput autoComplete="chrome-off" className={styles.input} {...props} />
);

Input.Password = AntdInput.Password;
Input.displayName = 'Input';

export default Input;
